module.exports = __webpack_public_path__ + "img/timmy-02.abd6a216.png";